import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { fetchAuthSession } from 'aws-amplify/auth';
import { sanitizeS3ObjectKey } from './exportFilename';

const EXTERNAL_BUCKET = 'vdura-quote-explorer';
const EXTERNAL_BUCKET_REGION = 'us-east-2';
const EXTERNAL_BUCKET_PREFIX = 'NewQuotes/';

/**
 * Uploads a file to the external vdura-quote-explorer S3 bucket using
 * the current user's Cognito Identity Pool credentials.
 * Requires s3:PutObject on the target bucket (granted via Cognito IAM role).
 *
 * @param {string} filename - bare filename, will be placed under NewQuotes/ after
 *   sanitizeS3ObjectKey (CONF-242) — the identity for every builder-made name
 * @param {Blob|string} body - file content
 * @param {string} contentType - MIME type
 */
export const uploadToExternalS3 = async (filename, body, contentType) => {
  const { credentials } = await fetchAuthSession();
  const client = new S3Client({ region: EXTERNAL_BUCKET_REGION, credentials });
  // AWS SDK v3 chunked encoding doesn't handle Blob in browsers — convert to Uint8Array first
  const uploadBody = body instanceof Blob ? new Uint8Array(await body.arrayBuffer()) : body;
  await client.send(new PutObjectCommand({
    Bucket: EXTERNAL_BUCKET,
    Key: `${EXTERNAL_BUCKET_PREFIX}${sanitizeS3ObjectKey(filename)}`,
    Body: uploadBody,
    ContentType: contentType,
  }));
};
